import Hero from "../Components/Hero";
import Navbar from "../Components/Navbar";
import homeImg from "../Assets/12.jpg";
import Destination from "../Components/Destination";
import Trip from "../Components/Trip";
import Footer from "../Components/Footer";

function Home() {
  return (
    <>
      <Navbar />
      <Hero
        cName="hero"
        heroImg={"https://media.istockphoto.com/id/1419410282/photo/silent-forest-in-spring-with-beautiful-bright-sun-rays.webp?b=1&s=170667a&w=0&k=20&c=0eyjD9xiGItjC1Yklk_q3Ry1Jr0zWAUJ6q8kDmBuyvk="}
        title="Your Gateway to the Paradise of Sri Lanka!"
        text="Choose Your Favourite Destination"
        buttonText="Travel Plan"
        url="/"
        btnClass="show"
      />
      <Destination />
      <Trip />
      <Footer />
    </>
  );
}

export default Home;
